import React from 'react';

import { OnlyAdminToConnectModal } from '@widgets/WidgetsShop/ui/Modals';

import { DetailsWidgetModal } from '../DetailsWidgetModal';
import { PaymentWidgetModal } from '../PaymentWidgetModal';
import { useWidgetModalFlow } from './model/useWidgetModalFlow';
import { useWidgetModals } from './model/useWidgetModals';

interface WidgetModalControllerProps {
    fromWidgetPage?: boolean;
}

export const WidgetModalController = ({ fromWidgetPage = false }: WidgetModalControllerProps) => {
    const { modal, close } = useWidgetModals();
    const { handleDetailsAction } = useWidgetModalFlow(fromWidgetPage);

    return (
        <>
            <DetailsWidgetModal
                action={handleDetailsAction}
                fromWidgetPage={fromWidgetPage}
                currentWidgetId={modal.type === 'details' ? modal.widgetId : null}
                isOpen={modal.type === 'details'}
                onCloseModal={close}
            />
            <PaymentWidgetModal
                isOpen={modal.type === 'payment'}
                fromWidgetPage={fromWidgetPage}
                currentWidgetId={modal.type === 'payment' ? modal.widgetId : null}
                onModalClose={close}
            />
            <OnlyAdminToConnectModal isOpen={modal.type === 'only-admin'} onClose={close} />
        </>
    );
};
